import { strapiFetch } from '../../../entities/@api/Strapi';
import { BlogOverviewRequestConfig, BlogOverviewResponse } from '../../../entities/@blog/BlogOverview/BlogOverview';
import { generateBlogOverviewQuery } from '../../../entities/@blog/BlogOverview/BlogOverviewRequests';
import { transformToBlogPost } from '../../../entities/@blog/BlogPost/BlogPostTransformers';
import { isFetchResultSuccessful } from '../../../entities/FetchResult/FetchResult';
import { transformStrapiPaginationToPagination } from '../../../entities/Pagination/PaginationTransformers';
import { ReduxFetchAction } from '../../defaults';
import {
    setError,
    setIsLoading,
    setIsSuccessful,
    setOverviews,
} from './blogOverviewsSlice';

export const fetchBlogOverview: ReduxFetchAction<BlogOverviewRequestConfig> = config => async (dispatch, getState) => {
    dispatch(setIsLoading(true));
    dispatch(setIsSuccessful(false));
    dispatch(setError(''));

    try {
        const query = generateBlogOverviewQuery(config);

        const overviewResponse = await strapiFetch<BlogOverviewResponse>(`/blogs?${query}`);

        if (!isFetchResultSuccessful(overviewResponse)) {
            dispatch(setError(overviewResponse.error));
            return;
        }

        const { data: blogOverviewData, meta: blogOverviewMeta } = overviewResponse.data;

        const blogPosts = blogOverviewData
            ? blogOverviewData.map(transformToBlogPost)
            : [];

        const overviewPagination = blogOverviewMeta
            ? transformStrapiPaginationToPagination(blogOverviewMeta.pagination)
            : undefined;

        const state = getState();
        const { overviews } = state.blogOverviewsSlice;

        const updatedOverviews = {
            ...overviews,
            [config.key]: {
                blogPosts,
                pagination: overviewPagination,
            },
        };

        dispatch(setOverviews(updatedOverviews));

        dispatch(setIsSuccessful(true));
    } catch (error) {
        console.error('[fetchBlogOverview]', error);
    } finally {
        dispatch(setIsLoading(false));
    }
};
